var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AreaFormModel } from '.';
import { TargetAreaTypes } from '../Constants';
import { MasterRepository } from '@/models/Master/MasterRepository';
import { groupBy, map } from 'lodash';
import { OfficeListedOptions } from '@/models/Menu/Constants';
var TemporaryOfficeMenuSettingFormModel = /** @class */ (function () {
    function TemporaryOfficeMenuSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, _b = _a.orderDescription, orderDescription = _b === void 0 ? {} : _b;
        var _c = orderDescription, _d = _c.industryClassificationTargets, industryClassificationTargets = _d === void 0 ? [] : _d, _e = _c.listingCategoryClassificationTarget, listingCategoryClassificationTarget = _e === void 0 ? {} : _e, _f = _c.employeesTarget, employeesTarget = _f === void 0 ? {} : _f, _g = _c.salesAmountTarget, salesAmountTarget = _g === void 0 ? {} : _g, _h = _c.administrativeDistrictType, administrativeDistrictType = _h === void 0 ? TargetAreaTypes.PREFECTURE : _h, area = _c.area, _j = _c.splitGroup, splitGroup = _j === void 0 ? false : _j, _k = _c.memo, memo = _k === void 0 ? '' : _k;
        this.id = id;
        var ict = industryClassificationTargets.map(function (industryClassificationTarget) {
            return IndustryClassificationTargetFormModel.assign(industryClassificationTarget);
        });
        var lcct = ListingCategoryClassificationTargetFormModel.assign(listingCategoryClassificationTarget);
        var et = EmployeesTargetFormModel.assign(employeesTarget);
        var sat = SalesAmountTargetFormModel.assign(salesAmountTarget);
        this.orderDescription = {
            industryClassificationTargets: ict,
            listingCategoryClassificationTarget: lcct,
            employeesTarget: et,
            salesAmountTarget: sat,
            administrativeDistrictType: administrativeDistrictType,
            area: AreaFormModel.assign(area),
            splitGroup: splitGroup,
            memo: memo,
            isValidIndustryClassification: industryClassificationTargets.length !== 0,
            isValidListingCategoryClassification: Object.keys(listingCategoryClassificationTarget).length !== 0 &&
                listingCategoryClassificationTarget.listingCategoryClassificationTargets
                    .length !== 0,
            isValidEmployees: Object.keys(employeesTarget).length !== 0,
            isValidSalesAmount: Object.keys(salesAmountTarget).length !== 0,
        };
    }
    TemporaryOfficeMenuSettingFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var masterIndustryClassificationList_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // areaの初期化処理
                    return [4 /*yield*/, this.orderDescription.area.init(this.orderDescription.administrativeDistrictType)
                        // 業務分類の初期化処理
                    ];
                    case 1:
                        // areaの初期化処理
                        _a.sent();
                        if (!this.orderDescription.isValidIndustryClassification) return [3 /*break*/, 3];
                        return [4 /*yield*/, MasterRepository.fetchLargeClassificationList()];
                    case 2:
                        masterIndustryClassificationList_1 = _a.sent();
                        this.orderDescription.industryClassificationTargets.map(function (industryClassificationTarget) { return __awaiter(_this, void 0, void 0, function () {
                            var masterIndustryClassification;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        masterIndustryClassification = masterIndustryClassificationList_1.find(function (item) {
                                            return item.sectorCode === industryClassificationTarget.sectorCode;
                                        });
                                        return [4 /*yield*/, industryClassificationTarget.init(masterIndustryClassification.name)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/, industryClassificationTarget];
                                }
                            });
                        }); });
                        _a.label = 3;
                    case 3:
                        if (!this.orderDescription.isValidListingCategoryClassification) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.orderDescription.listingCategoryClassificationTarget.init()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TemporaryOfficeMenuSettingFormModel.prototype, "isSimulatable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryOfficeMenuSettingFormModel.prototype, "isNew", {
        get: function () {
            return !this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryOfficeMenuSettingFormModel.prototype, "hasNoConditions", {
        get: function () {
            return (!this.orderDescription.isValidIndustryClassification &&
                !this.orderDescription.isValidListingCategoryClassification &&
                !this.orderDescription.isValidEmployees &&
                !this.orderDescription.isValidSalesAmount);
        },
        enumerable: false,
        configurable: true
    });
    TemporaryOfficeMenuSettingFormModel.prototype.makeIndustryClassificationTargets = function (industryClassificationTargets) {
        var itemListGroupByParent = groupBy(industryClassificationTargets, function (item) { return item.parentId; });
        this.orderDescription.industryClassificationTargets = map(itemListGroupByParent, function (item) {
            return IndustryClassificationTargetFormModel.makeIndustryClassificationTarget(item);
        });
    };
    TemporaryOfficeMenuSettingFormModel.prototype.makeListingCategoryClassification = function (value) {
        this.orderDescription.listingCategoryClassificationTarget = ListingCategoryClassificationTargetFormModel.makeListingCategoryClassification(value);
    };
    return TemporaryOfficeMenuSettingFormModel;
}());
export { TemporaryOfficeMenuSettingFormModel };
var IndustryClassificationTargetFormModel = /** @class */ (function () {
    function IndustryClassificationTargetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.industryClassificationCodes, industryClassificationCodes = _b === void 0 ? [] : _b, _c = _a.sectorCode, sectorCode = _c === void 0 ? '' : _c, _d = _a.name, name = _d === void 0 ? '' : _d, _e = _a.industryClassificationCodeAndNames, industryClassificationCodeAndNames = _e === void 0 ? [] : _e;
        this.industryClassificationCodes = industryClassificationCodes;
        this.sectorCode = sectorCode;
        this.name = name;
        this.industryClassificationCodeAndNames = industryClassificationCodeAndNames;
    }
    IndustryClassificationTargetFormModel.assign = function (item) {
        return new IndustryClassificationTargetFormModel(item);
    };
    IndustryClassificationTargetFormModel.prototype.init = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var masterSmallClassificationList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.name = name;
                        return [4 /*yield*/, MasterRepository.fetchSmallClassificationList({
                                sectorCode: this.sectorCode,
                            })];
                    case 1:
                        masterSmallClassificationList = _a.sent();
                        this.industryClassificationCodeAndNames = this.industryClassificationCodes.map(function (code) {
                            var masterSmallClassification = masterSmallClassificationList.find(function (item) { return item.id === code; });
                            return IndustryClassificationCodeAndName.assign({
                                code: code,
                                name: masterSmallClassification.name,
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    IndustryClassificationTargetFormModel.makeIndustryClassificationTarget = function (itemList) {
        var industryClassificationCodeAndNames = itemList.map(function (item) {
            return IndustryClassificationCodeAndName.assign({
                code: item.id,
                name: item.name,
            });
        });
        var industryClassificationCodes = industryClassificationCodeAndNames.map(function (item) { return item.code; });
        return IndustryClassificationTargetFormModel.assign({
            industryClassificationCodes: industryClassificationCodes,
            sectorCode: itemList[0].parentId,
            name: itemList[0].parentName,
            industryClassificationCodeAndNames: industryClassificationCodeAndNames,
        });
    };
    return IndustryClassificationTargetFormModel;
}());
var IndustryClassificationCodeAndName = /** @class */ (function () {
    function IndustryClassificationCodeAndName(item) {
        if (item === void 0) { item = {}; }
        var _a = item, code = _a.code, _b = _a.name, name = _b === void 0 ? '' : _b;
        this.code = code;
        this.name = name;
    }
    IndustryClassificationCodeAndName.assign = function (item) {
        return new IndustryClassificationCodeAndName(item);
    };
    return IndustryClassificationCodeAndName;
}());
var ListingCategoryClassificationTargetFormModel = /** @class */ (function () {
    function ListingCategoryClassificationTargetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.listingCategoryClassificationTargets, listingCategoryClassificationTargets = _b === void 0 ? [] : _b, _c = _a.listingCategoryClassificationTargetKeyAndNames, listingCategoryClassificationTargetKeyAndNames = _c === void 0 ? [] : _c;
        this.listingCategoryClassificationTargets = listingCategoryClassificationTargets;
        this.listingCategoryClassificationTargetKeyAndNames = listingCategoryClassificationTargetKeyAndNames;
    }
    ListingCategoryClassificationTargetFormModel.assign = function (item) {
        return new ListingCategoryClassificationTargetFormModel(item);
    };
    ListingCategoryClassificationTargetFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.listingCategoryClassificationTargetKeyAndNames = this.listingCategoryClassificationTargets.map(function (target) {
                    return ListingCategoryClassificationTargetKeyAndName.assign(OfficeListedOptions.find(function (option) { return option.key === target; }));
                });
                return [2 /*return*/];
            });
        });
    };
    ListingCategoryClassificationTargetFormModel.makeListingCategoryClassification = function (listingCategoryClassifications) {
        var listingCategoryClassificationTargetKeyAndNames = listingCategoryClassifications
            .filter(function (target) { return target.value; })
            .map(function (target) {
            return ListingCategoryClassificationTargetKeyAndName.assign({
                key: target.key,
                name: target.name,
            });
        });
        var listingCategoryClassificationTargets = listingCategoryClassificationTargetKeyAndNames.map(function (target) { return target.key; });
        return ListingCategoryClassificationTargetFormModel.assign({
            listingCategoryClassificationTargets: listingCategoryClassificationTargets,
            listingCategoryClassificationTargetKeyAndNames: listingCategoryClassificationTargetKeyAndNames,
        });
    };
    return ListingCategoryClassificationTargetFormModel;
}());
var ListingCategoryClassificationTargetKeyAndName = /** @class */ (function () {
    function ListingCategoryClassificationTargetKeyAndName(item) {
        if (item === void 0) { item = {}; }
        var _a = item, key = _a.key, _b = _a.name, name = _b === void 0 ? '' : _b;
        this.key = key;
        this.name = name;
    }
    ListingCategoryClassificationTargetKeyAndName.assign = function (item) {
        return new ListingCategoryClassificationTargetKeyAndName(item);
    };
    return ListingCategoryClassificationTargetKeyAndName;
}());
var EmployeesTargetFormModel = /** @class */ (function () {
    function EmployeesTargetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.minEmployees, minEmployees = _b === void 0 ? 1 : _b, _c = _a.maxEmployees, maxEmployees = _c === void 0 ? null : _c;
        this.minEmployees = minEmployees;
        this.maxEmployees = maxEmployees;
    }
    EmployeesTargetFormModel.assign = function (item) {
        return new EmployeesTargetFormModel(item);
    };
    return EmployeesTargetFormModel;
}());
var SalesAmountTargetFormModel = /** @class */ (function () {
    function SalesAmountTargetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.minSalesAmount, minSalesAmount = _b === void 0 ? 0 : _b, _c = _a.maxSalesAmount, maxSalesAmount = _c === void 0 ? null : _c;
        this.minSalesAmount = minSalesAmount;
        this.maxSalesAmount = maxSalesAmount;
    }
    SalesAmountTargetFormModel.assign = function (item) {
        return new SalesAmountTargetFormModel(item);
    };
    return SalesAmountTargetFormModel;
}());
